export default __webpack_public_path__ + "static/media/instagram.2df697b5.png";